'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestPharmacyState$Both(chat, response) {
  this.Lapp_api_DrugRequestPharmacyState$Both__f_chat = null;
  this.Lapp_api_DrugRequestPharmacyState$Both__f_response = null;
  this.Lapp_api_DrugRequestPharmacyState$Both__f_chat = chat;
  this.Lapp_api_DrugRequestPharmacyState$Both__f_response = response;
}
export { $c_Lapp_api_DrugRequestPharmacyState$Both as $c_Lapp_api_DrugRequestPharmacyState$Both };
$c_Lapp_api_DrugRequestPharmacyState$Both.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestPharmacyState$Both.prototype.constructor = $c_Lapp_api_DrugRequestPharmacyState$Both;
/** @constructor */
function $h_Lapp_api_DrugRequestPharmacyState$Both() {
}
export { $h_Lapp_api_DrugRequestPharmacyState$Both as $h_Lapp_api_DrugRequestPharmacyState$Both };
$h_Lapp_api_DrugRequestPharmacyState$Both.prototype = $c_Lapp_api_DrugRequestPharmacyState$Both.prototype;
$c_Lapp_api_DrugRequestPharmacyState$Both.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_api_DrugRequestPharmacyState$Both.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1517612310, true);
});
$c_Lapp_api_DrugRequestPharmacyState$Both.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_DrugRequestPharmacyState$Both)) {
    var x = this.Lapp_api_DrugRequestPharmacyState$Both__f_chat;
    var x$2 = x$0.Lapp_api_DrugRequestPharmacyState$Both__f_chat;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lapp_api_DrugRequestPharmacyState$Both__f_response;
      var x$4 = x$0.Lapp_api_DrugRequestPharmacyState$Both__f_response;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_api_DrugRequestPharmacyState$Both.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_api_DrugRequestPharmacyState$Both.prototype.productArity__I = (function() {
  return 2;
});
$c_Lapp_api_DrugRequestPharmacyState$Both.prototype.productPrefix__T = (function() {
  return "Both";
});
$c_Lapp_api_DrugRequestPharmacyState$Both.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_api_DrugRequestPharmacyState$Both__f_chat;
  }
  if ((n === 1)) {
    return this.Lapp_api_DrugRequestPharmacyState$Both__f_response;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_DrugRequestPharmacyState$Both.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "chat";
  }
  if ((n === 1)) {
    return "response";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_api_DrugRequestPharmacyState$Both(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_DrugRequestPharmacyState$Both)));
}
export { $isArrayOf_Lapp_api_DrugRequestPharmacyState$Both as $isArrayOf_Lapp_api_DrugRequestPharmacyState$Both };
var $d_Lapp_api_DrugRequestPharmacyState$Both = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestPharmacyState$Both, "app.api.DrugRequestPharmacyState$Both", ({
  Lapp_api_DrugRequestPharmacyState$Both: 1,
  Lapp_api_DrugRequestPharmacyState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_api_DrugRequestPharmacyState$Both as $d_Lapp_api_DrugRequestPharmacyState$Both };
//# sourceMappingURL=app.api.-Drug-Request-Pharmacy-State$-Both.js.map
